export default "__VITE_ASSET__BxZmH3Tg__"